import { render } from "./RoundPopUp.vue?vue&type=template&id=a499ff20&scoped=true"
import script from "./RoundPopUp.vue?vue&type=script&lang=js"
export * from "./RoundPopUp.vue?vue&type=script&lang=js"

import "./RoundPopUp.vue?vue&type=style&index=0&id=a499ff20&lang=css"
import "./RoundPopUp.vue?vue&type=style&index=1&id=a499ff20&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a499ff20"]])

export default __exports__